// @flow
import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { Input } from '@mzvonar/modular-redux-form';
import makeStyles from "@material-ui/core/styles/makeStyles";
import { Shape } from '../../../types';
import Field from '../../ui/form/Field';

const useStyles = makeStyles(theme => ({
    input: {
        marginTop: theme.spacing(1),
        marginLeft: theme.spacing(.5),
        marginRight: theme.spacing(.5),
        marginBottom: theme.spacing(1),
        '& .MuiFormControl-marginDense': {
            margin: 0,
        },
        '& .MuiFilledInput-inputMarginDense': {
            padding: theme.spacing(1),
        }
    }
}));

export type Props = $ReadOnly<{
    name: string,
    shape: Shape,

    inputChange: (name: string, value: mixed) => void,
    setShape: (shape: Shape) => void
}>;

function Circle({ name, shape, inputChange, setShape }: Props) {
    const classes = useStyles();

    const center = shape.center;
    const radius = shape.radius;
    const centerLatName = `${name}.center.lat`;
    const centerLonName = `${name}.center.lon`;
    const radiusName = `${name}.radius`;

    const onCenterXChange = (e) => {
        let value = parseFloat(e.target.value);
        value = isNaN(value) ? undefined : value;

        if(value !== shape.center[0]) {
            setShape({
                ...shape,
                center: [value, shape.center[1]]
            });
        }
    };
    const onCenterYChange = (e) => {
        let value = parseFloat(e.target.value);
        value = isNaN(value) ? undefined : value;

        if(value !== shape.center[1]) {
            setShape({
                ...shape,
                center: [shape.center[0], value]
            });
        }
    };
    const onRadiusChange = (e) => {
        let value = parseFloat(e.target.value);
        value = isNaN(value) ? undefined : value;

        if(value !== shape.radius) {
            setShape({
                ...shape,
                radius: value
            });
        }
    };

    useEffect(() => {
        inputChange(centerLatName, center[0]);
        inputChange(centerLonName, center[1]);
    }, [centerLatName, centerLonName, center]);
    useEffect(() => {
        inputChange(radiusName, radius);
    }, [radiusName, radius]);

    return (
        <Table>
            <TableBody>
                <TableRow>
                    <TableCell size="small" padding="none">
                        <FormattedMessage
                            id="newZoneForm.shape.circle.center"
                            defaultMessage="Center"
                        />
                    </TableCell>
                    <TableCell size="small" padding="none">
                        <Input
                            className={classes.input}
                            id={centerLatName}
                            name={centerLatName}
                            component={Field}
                            validate={['required']}
                            onChange={onCenterXChange}
                        />
                    </TableCell>
                    <TableCell size="small" padding="none">
                        <Input
                            className={classes.input}
                            id={centerLonName}
                            name={centerLonName}
                            component={Field}
                            validate={['required']}
                            onChange={onCenterYChange}
                        />
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell size="small" padding="none">
                        <FormattedMessage
                            id="newZoneForm.shape.circle.radius"
                            defaultMessage="Radius"
                        />
                    </TableCell>
                    <TableCell size="small" padding="none" colSpan={2}>
                        <Input
                            className={classes.input}
                            id={radiusName}
                            name={radiusName}
                            component={Field}
                            validate={['required']}
                            onChange={onRadiusChange}
                        />
                    </TableCell>
                </TableRow>
            </TableBody>
        </Table>
    );
}

export default Circle